/*
 * This file is only partially migrated
 */

import { EventOpenDiscountData } from '../../types/events';

export function isPromoCodeActive(
    openDiscount: EventOpenDiscountData | undefined,
): openDiscount is EventOpenDiscountData {
    if (!openDiscount) {
        return false;
    }

    const { endDate, quantityAvailable, quantitySold } = openDiscount;
    const isOnSale = new Date() <= new Date(endDate);
    const hasTicketsAvailable = quantityAvailable === 0 || quantitySold < quantityAvailable;

    return isOnSale && hasTicketsAvailable;
}
